import axios from 'axios'

const baseDomain = 'https://api.branvit.com'
// const baseDomain = 'https://api.bvtools.rakha.grvty.xyz'
// const baseDomain = 'http://localhost:8000'
const baseURL = `${baseDomain}/v1`
const apiKey = 'cGpNKrjLaI4d5QCuYsXFFPHETYVhu7Db'

export default axios.create({
    baseURL: baseURL,
    headers: {
        'x-api-key': apiKey
    }
})